import { useEffect } from 'react';

import { useCurrentApp } from '../hooks';

/**
 * Mounts a zero-DOM effect that keeps `body.className` in sync with
 * `theme-{theme_id}` for the current route. Renders nothing.
 *
 * Place once at the router root (alongside `<Routes>`). Works for both
 * desktop and PWA because `useCurrentApp` already handles the two route
 * schemas (`/apps/:slug/...` vs `/:slug/...`).
 */
export function ThemeBodyClass(): null {
  const appId = useCurrentApp();

  useEffect(() => {
    const body = document.body;
    // Strip any existing `theme-*` classes so switching apps doesn't stack them.
    body.className = body.className.replace(/\btheme-\S+\b/g, '').trim();
    body.classList.add(`theme-${appId}`);
  }, [appId]);

  return null;
}
